// extracted by mini-css-extract-plugin
export default {"root":"DownloadApp_root__SFg7X","link":"DownloadApp_link__9ERCR"};